import React, { useEffect, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';

// Shows a quiet prompt when the main process has finished downloading an
// update. "Restart now" applies it immediately; dismissing it is fine too —
// the update installs automatically the next time the app quits.
const UpdateNotifier = () => {
  const [update, setUpdate] = useState(null);

  useEffect(() => {
    if (!window.electronAPI || !window.electronAPI.onUpdateReady) return undefined;
    window.electronAPI.onUpdateReady((info) => setUpdate(info || {}));
    return () => {
      if (window.electronAPI.removeAllListeners) {
        window.electronAPI.removeAllListeners('update-ready');
      }
    };
  }, []);

  if (!update) return null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        sx={{ alignItems: 'center' }}
        action={
          <>
            <Button
              color="inherit"
              size="small"
              onClick={() => window.electronAPI.installUpdate()}
            >
              Restart now
            </Button>
            <Button color="inherit" size="small" onClick={() => setUpdate(null)}>
              Later
            </Button>
          </>
        }
      >
        {`Update ${update.version ? `v${update.version} ` : ''}downloaded — restart to apply. Your data is untouched.`}
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotifier;
